import styles from './styles.scss';
import cn from 'classnames';

type OwnProps = React.HTMLAttributes<HTMLButtonElement>;

export const ClearButton = ({ children, className, ...props }: OwnProps) => (
  <button {...props} className={cn(styles.clearButton, className)}>
    {children}
  </button>
);
